import React, { useState } from "react";

import Slider from "components/common/SliderInfo/SliderInfo";

import envs from "config/envs";

import * as S from "./CnpHoldingPresenceInfo.style";

const CnpHoldingPresenceInfo = () => {
  const sliders = [
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_map_customer.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_icon_customer.webp`,
      alt: "Mais de 4 milhões de clientes",
      title: "+ 4 milhões",
      description: "de clientes",
      activeKey: "customers",
    },
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_map_employees.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_icon_employees.webp`,
      alt: "Somos 465 colaboradores",
      title: "465",
      description: "colaboradores",
      activeKey: "employees",
    },
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_map_invoicing.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_icon_invoicing.webp`,
      alt: "Temos um faturamento de 5,21 bilhões de reais",
      title: "5,21 bilhões de reais",
      description: "de valor econômico direto gerado",
      activeKey: "invoicing",
    },
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_map_profit.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_icon_profit.webp`,
      alt: "Já somamos 1,16 bilhão de reais em lucro líquido",
      title: "1,16 bilhão de reais",
      description: "em lucro líquido",
      activeKey: "profit",
    },
  ];

  const slidesPresenceInfo = (
    <>
      {sliders.map((slide, index) => {
        return (
          <S.SlideCard
            key={index}
            icon={slide.icon}
            map={slide.map}
            title={slide.title}
            alt={slide.alt}
            description={slide.description}
          />
        );
      })}
    </>
  );

  const [map, setMap] = useState({
    img: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/ourhistory_map_customer.webp`,
    alt: sliders[0].alt,
  });
  const [active, setActive] = useState(sliders[0].activeKey);

  const handleUpdateSlide = (newMap, newAlt, newActive) => {
    setMap({
      img: newMap,
      alt: newAlt,
    });
    setActive(newActive);
  };

  return (
    <>
      <S.Content>
        <S.DesktopOnly>
          <S.Container>
            <S.ContainerContent>
              <S.Title variant="headline-02" color="primary-dark">
                Nossa presença <br /> no Brasil
              </S.Title>
              {sliders.map((slide, index) => {
                return (
                  <S.CardInfo
                    key={index}
                    onMouseOver={() =>
                      handleUpdateSlide(slide.map, slide.alt, slide.activeKey)
                    }
                    active={active == slide.activeKey ? true : false}
                  >
                    <S.CardIcon
                      width="auto"
                      height="auto"
                      src={slide.icon}
                      alt={slide.alt}
                    />
                    <S.CardContainer>
                      <S.CardTitle variant="headline-03">
                        {slide.title}
                      </S.CardTitle>
                      <S.Description>{slide.description}</S.Description>
                    </S.CardContainer>
                  </S.CardInfo>
                );
              })}
              <S.Paragraph>
                Dados baseados no relatório de sustentabilidade de 2023 da CNP
                Seguros Holding Brasil
              </S.Paragraph>
            </S.ContainerContent>
            <S.ContainerImage
              width="auto"
              height="auto"
              src={map.img}
              alt={map.alt}
            />
          </S.Container>
        </S.DesktopOnly>
        <S.MobileOnly>
          <S.Title variant="headline-02" color="primary-dark">
            Nossa presença <br /> no Brasil
          </S.Title>
          <Slider>{slidesPresenceInfo.props.children}</Slider>
        </S.MobileOnly>
      </S.Content>
    </>
  );
};

export default CnpHoldingPresenceInfo;
